<template>
  <m-dialog ref="previewCustomDlg" :btnsave="false" title="PREVIEW KTA">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="12" lg="10" xl="7">
        <v-card>
          <v-card-text>
            <v-row v-for="preview in items" :key="preview.index">
              <v-col cols="12" sm="12" md="6" lg="6" align-end colbox>
                <img height="250" class="pa-2" :src="preview.url_kta_depan ? preview.url_kta_depan : 'img/no-image.jpeg'" alt="avatar" />
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" align-end colbox>
                <img height="250" class="pa-2" :src="preview.url_kta_belakang ? preview.url_kta_belakang : 'img/no-image.jpeg'" alt="avatar" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :small="$vuetify.breakpoint.smAndDown" depressed color="success" @click="cetakKTA()"> <v-icon>mdi-file-pdf-box</v-icon>Cetak KTA PDF </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
// const lc = window.localStorage;
// const TOKEN = "siapbbjatimtoken";
// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor";
// import { API } from "@/const";
// const M_API = API + "/api";
export default {
  components: {
    VueEditor
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      items: [],
      range: null,
      kotaid: null
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj, range, kotaid) {
      this.items = obj;
      this.range = range;
      this.kotaid = kotaid;
      let x = this.$refs.previewCustomDlg.open();
      this.$validator.reset();
      this.isReset = true;
      this.$nextTick(() => {
        this.isReset = false;
      });
      return x;
    },
    cetakKTA() {
      this.$store
        .dispatch("warga/cetakCustom", { obj: this.range, kota_id: this.kotaid })
        .then(() => {})
        .catch(e => e);
    }
  }
};
</script>
